module.exports = __webpack_public_path__ + "static/1_1-712e86f180ff21cf21c21cec17c11102.jpg";